import { call, delay, race, select } from 'redux-saga/effects';

import {
  configurationSettledSelector,
  useOidcSelector,
} from '../../store/entities/selectors/configuration';
import { TOKEN_PROVIDERS } from '../tokens';
import { waitFor } from './waitFor';

// How long a login is willing to wait for GET /configuration before falling
// back to the legacy provider. Configuration is requested at saga start on
// both platforms, so this only matters on a very slow first launch.
const CONFIGURATION_WAIT_MS = 5000;

/**
 * Decide which token provider a *new* login uses: `'oidc'` when the remote
 * `authentication.useOidc` flag is on, `'auth'` (legacy) otherwise. Waits,
 * bounded, for the initial configuration request to settle so a login that
 * starts right after launch sees the live flag rather than the default.
 *
 * Only for starting logins. Refresh, revocation and the apiFetch refresh hooks
 * branch on the stored session's provider marker instead (services/tokens.js).
 */
export function* resolveLoginProvider() {
  yield race({
    settled: call(waitFor, configurationSettledSelector),
    timeout: delay(CONFIGURATION_WAIT_MS),
  });

  const useOidc = yield select(useOidcSelector);
  return useOidc ? TOKEN_PROVIDERS.OIDC : TOKEN_PROVIDERS.LEGACY;
}
